<template>
  <div class="masker">
    <transition name="actionSheet-fade" appear @after-leave="leave">
      <div class="actionSheet" v-show="show">
        <div class="title" :style="title.style || ''">
			<div class="close" style="right: 0;" @click="clickItem('cancel')"></div>
			{{title.txt ||title}}
		</div>
		<ul class="select clearfix">
			<li v-for="(item, index) in list" :key = "index">
				<input type="radio" :id="item" :value="item" v-model="select">
				<label :for="item">{{item}}</label>
			</li>
		</ul>
		<div style="margin: 10px 54px;">
			<p style="text-align:left">建议</p>
			<div class="textarea" contenteditable="true" placeholder="请输入您的建议" id="advice"></div>
		</div>
		<div class="btnline">
			<button class="btntrue" @click="clickItem(select)">确定</button>
			<button class="btncancle" style="margin-left:30px" @click="clickItem('cancel')">取消</button>
		</div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'actionSheet',
  data() {
    return {
	  show: true,
	  select:"满意",
      title: {
		txt: '您对本次服务是否满意？',
		style:{
			'position':'relative',
		}
      },
      list: ["非常满意", "满意", "不满意"],
      cancel: "暂不评价",
      clickEvent: () => {}
    }
  },
  methods: {
    clickItem(item) {
			item = this.list.lastIndexOf(item)
			var advice = $('#advice').text()
      this.clickEvent && this.clickEvent(item,advice);
      this.show = false;
    },
    leave() {
      document.body.removeChild(this.$el);
    }
  }
}
</script>
<style scoped>
	.select{
		margin:10px
	}
	.select input{
		-webkit-appearance: radio;
	}
	.select li{
		list-style: none;
		height: 30px;
		float: left;
		width: 33%;
		line-height: 30px;
	}
	.select label{
		cursor: pointer;
	}
	.textarea {
		text-align: left ;
		height: 100px;
		padding: 4px;
		border: 1px solid #888;
		overflow: auto;
		}

	.textarea:empty:before {
		content: attr(placeholder);
		color: #bbb;
		}
	.btnline{
		position: relative;
	}
	.btnline .btntrue {
		color: #ffffff;
		font-size: 14px;
		padding: 6px 20px 6px 20px;
		background: #4A90E2;
		border:none;
		cursor: pointer;
		}

	.btnline .btntrue:hover {
		background: #2980b9;
		color: #ffffff;
		}
	.btnline .btncancle{
		color: #666666;
		font-size: 14px;
		padding: 6px 20px 6px 20px;
		background: #F5F5F5;
		border:none;
		cursor: pointer;
	}
	.btnline .btncancle:hover {
		background: #d4d6d7;
		color: #ffffff;
		}
</style>



// WEBPACK FOOTER //
// src/components/dialog/ActionSheet.vue